import { render, staticRenderFns } from "./FieldSiteAdmin.vue?vue&type=template&id=5212d7f1&scoped=true&"
import script from "./FieldSiteAdmin.vue?vue&type=script&lang=js&"
export * from "./FieldSiteAdmin.vue?vue&type=script&lang=js&"
import style0 from "./FieldSiteAdmin.vue?vue&type=style&index=0&id=5212d7f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5212d7f1",
  null
  
)

export default component.exports